/* eslint-disable react/jsx-max-props-per-line */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import NumberFormat from 'react-number-format';
import { getMetaPessoalPresets } from './metaPessoalSession';

const MetaPessoalPicker = ({
  lenteId,
  metaDiaria,
  alvoDiario,
  onChange,
  disabled,
  unitLabel,
}) => {
  const presets = useMemo(
    () => getMetaPessoalPresets(lenteId, metaDiaria),
    [lenteId, metaDiaria],
  );
  const presetValue = presets.includes(alvoDiario) ? alvoDiario : null;
  const customValue = presetValue != null ? '' : (alvoDiario ?? '');

  return (
    <Stack spacing={0.75}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        Alvo / dia útil
      </Typography>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        <ToggleButtonGroup
          exclusive
          size="small"
          value={presetValue}
          disabled={disabled}
          onChange={(_, next) => {
            if (next) onChange(next);
          }}
          aria-label="Alvo diário pessoal"
        >
          {presets.map((preset) => (
            <ToggleButton key={preset} value={preset} sx={{ px: 1.5, py: 0.25, minWidth: 44 }}>
              {preset}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Typography variant="body2" color="text.secondary">
          ou
        </Typography>
        <NumberFormat
          customInput={TextField}
          size="small"
          name="metaPessoalCustom"
          value={customValue === '' ? '' : String(customValue)}
          onValueChange={(data) => {
            if (data.floatValue == null) return;
            onChange(data.floatValue);
          }}
          disabled={disabled}
          placeholder=""
          decimalScale={0}
          thousandSeparator=""
          allowNegative={false}
          inputProps={{
            'aria-label': `Alvo personalizado (${unitLabel})`,
            inputMode: 'numeric',
          }}
          sx={{
            width: 48,
            '& .MuiOutlinedInput-root': {
              height: 32,
              minHeight: 32,
              maxHeight: 32,
            },
            '& .MuiOutlinedInput-root:not(.MuiInputBase-multiline)': {
              minHeight: 32,
            },
            '& .MuiOutlinedInput-input': {
              py: 0,
              px: 0.5,
              fontSize: 13,
              lineHeight: '32px',
              textAlign: 'center',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              legend: { display: 'none' },
            },
            '& fieldset': {
              top: 0,
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

MetaPessoalPicker.propTypes = {
  lenteId: PropTypes.string,
  metaDiaria: PropTypes.number,
  alvoDiario: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  unitLabel: PropTypes.string,
};

MetaPessoalPicker.defaultProps = {
  lenteId: null,
  metaDiaria: null,
  alvoDiario: null,
  disabled: false,
  unitLabel: 'serviços',
};

export default MetaPessoalPicker;
